import { cn } from "@/lib/utils";

interface LogoProps {
  /** Total height in px. Width auto-scales to keep aspect ratio. */
  size?: number;
  /** Show the "ALIA" wordmark to the right of the glyph. */
  showWordmark?: boolean;
  className?: string;
}

/**
 * Alia logo. Renders the official PNG (white silver A with cyan orb,
 * transparent background) so it sits cleanly on any surface.
 */
export function Logo({ size = 28, showWordmark = true, className }: LogoProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-2.5 select-none",
        className
      )}
      style={{ height: size }}
    >
      <img
        src="/alia-logo.png"
        alt="Alia"
        height={size}
        style={{ height: size, width: "auto" }}
        draggable={false}
        className="block"
      />

      {showWordmark && (
        <span className="text-[15px] font-semibold tracking-[0.18em] text-foreground">
          ALIA
        </span>
      )}
    </span>
  );
}
